import React from 'react';

export const Notifications: React.FC = () => {
  return (
    <div className='text-white mt-app-base text-app-lg flex justify-center'>
      <p>You don&apos;t have any notifications</p>
    </div>
  );
};
